/**
 * Mega-menu: Women and Men. Spotlight = editorial image (not a product tile).
 *
 * Links use real `/shop/:categorySlug` PLPs from the category tree (`scripts/seedCategories.js`).
 * Where browse tags exist (`server/config/browseTagSeeds.js`), facets use `?tag=<slug>`.
 */
import imgWomen from '../assets/hero-women.jpg';
import imgMen from '../assets/hero-men.jpg';
import imgAccessories from '../assets/look-4.jpg';

export const womenMega = {
  columns: [
    {
      heading: 'CLOTHING',
      to: '/shop/women',
      links: [
        { label: 'All Clothing', to: '/shop/women' },
        { label: 'Best Sellers', to: '/shop/bestsellers' },
        { label: 'New In', to: '/shop/new' },
        { label: 'Knitwear', to: '/shop/knitwear' },
        { label: 'Outerwear', to: '/shop/outerwear' },
      ],
    },
    {
      heading: 'DRESSES',
      to: '/shop/dresses',
      links: [
        { label: 'All Dresses', to: '/shop/dresses' },
        { label: 'Mini Dresses', to: '/shop/dresses?tag=mini' },
        { label: 'Maxi Dresses', to: '/shop/dresses?tag=maxi' },
        { label: 'Midi Dresses', to: '/shop/dresses?tag=midi' },
        { label: 'Formal Dresses', to: '/shop/dresses?tag=formal' },
        { label: 'Day Dresses', to: '/shop/dresses?tag=day' },
        { label: 'Party Dresses', to: '/shop/dresses?tag=party' },
        { label: 'Lace Dresses', to: '/shop/dresses?tag=lace' },
        { label: 'Evening', to: '/shop/dresses?tag=evening' },
      ],
    },
    {
      heading: 'TOPS',
      to: '/shop/blouses-tops',
      links: [
        { label: 'All Tops', to: '/shop/blouses-tops' },
        { label: 'Going Out Tops', to: '/shop/blouses-tops?tag=going-out' },
        { label: 'Bustiers & Corsets', to: '/shop/blouses-tops?tag=corsets' },
        { label: 'T-Shirts & Tees', to: '/shop/blouses-tops?tag=tees' },
        { label: 'Basic Tops', to: '/shop/blouses-tops?tag=basics' },
        { label: 'Tank Tops', to: '/shop/blouses-tops?tag=tanks' },
        { label: 'Halter Tops', to: '/shop/blouses-tops?tag=halter' },
        { label: 'Crop Tops', to: '/shop/blouses-tops?tag=crop' },
      ],
    },
    {
      heading: 'BOTTOMS',
      to: '/shop/skirts',
      links: [
        { label: 'All Bottoms', to: '/shop/women' },
        { label: 'All Skirts', to: '/shop/skirts' },
        { label: 'Mini Skirts', to: '/shop/skirts?tag=mini' },
        { label: 'Midi Skirts', to: '/shop/skirts?tag=midi' },
        { label: 'Maxi Skirts', to: '/shop/skirts?tag=maxi' },
        { label: 'A-line', to: '/shop/skirts?tag=a-line' },
        { label: 'Pencil Skirts', to: '/shop/skirts?tag=pencil' },
        { label: 'Pleated', to: '/shop/skirts?tag=pleated' },
        { label: 'Blazers', to: '/shop/womens-blazers' },
      ],
    },
    {
      heading: 'KNITWEAR & SETS',
      to: '/shop/knitwear',
      links: [
        { label: 'All Knitwear', to: '/shop/knitwear' },
        { label: 'Women\'s Sweaters', to: '/shop/womens-sweater' },
        { label: 'Lounge Sets', to: '/shop/lounge?tag=sets' },
        { label: 'Pants Sets', to: '/shop/lounge?tag=pants-sets' },
        { label: 'Going Out Sets', to: '/shop/lounge?tag=going-out-sets' },
        { label: 'Resort & Swim', to: '/collections' },
      ],
    },
  ],
  spotlight: {
    image: imgWomen,
    to: '/shop/women',
    alt: '',
  },
};

export const menMega = {
  columns: [
    {
      heading: 'CLOTHING',
      to: '/shop/men',
      links: [
        { label: 'All Clothing', to: '/shop/men' },
        { label: 'New In', to: '/shop/new' },
        { label: 'Best Sellers', to: '/shop/bestsellers' },
        { label: 'Knitwear', to: '/shop/knitwear' },
        { label: 'Outerwear', to: '/shop/outerwear' },
      ],
    },
    {
      heading: 'TOPS',
      to: '/shop/shirts',
      links: [
        { label: 'All Tops', to: '/shop/men' },
        { label: 'All Shirts', to: '/shop/shirts' },
        { label: 'T-Shirts & Tees', to: '/shop/shirts?tag=tees' },
        { label: 'Shirts', to: '/shop/shirts' },
        { label: 'Polos', to: '/shop/shirts?tag=polo' },
        { label: 'Sweaters & Hoodies', to: '/shop/sweater' },
        { label: 'Knitwear hub', to: '/shop/knitwear' },
      ],
    },
    {
      heading: 'JACKETS',
      to: '/shop/jackets',
      links: [
        { label: 'All Jackets', to: '/shop/jackets' },
        { label: 'Casual', to: '/shop/jackets?tag=casual' },
        { label: 'Bomber', to: '/shop/jackets?tag=bomber' },
        { label: 'Leather', to: '/shop/jackets?tag=leather' },
        { label: 'Puffer', to: '/shop/jackets?tag=puffer' },
        { label: 'Denim', to: '/shop/jackets?tag=denim' },
        { label: 'Winter', to: '/shop/jackets?tag=winter' },
      ],
    },
    {
      heading: 'BOTTOMS',
      to: '/shop/trousers',
      links: [
        { label: 'All Trousers', to: '/shop/trousers' },
        { label: 'Jeans', to: '/shop/trousers?tag=jeans' },
        { label: 'Chinos', to: '/shop/trousers?tag=chinos' },
        { label: 'Tailored', to: '/shop/trousers?tag=tailored' },
        { label: 'Shorts', to: '/shop/trousers?tag=shorts' },
        { label: 'Joggers', to: '/shop/trousers?tag=joggers' },
        { label: 'Sweatpants', to: '/shop/lounge?tag=sweatpants' },
      ],
    },
    {
      heading: 'TAILORING & SUITS',
      to: '/shop/suits',
      links: [
        { label: 'Suits', to: '/shop/suits' },
        { label: 'Two-piece', to: '/shop/suits?tag=two-piece' },
        { label: 'Blazers', to: '/shop/blazers' },
        { label: 'Tailoring hub', to: '/shop/tailoring' },
        { label: 'Lounge', to: '/shop/lounge' },
      ],
    },
    {
      heading: 'EDITS',
      to: '/collections',
      links: [
        { label: 'Lounge', to: '/shop/lounge' },
        { label: 'Resort', to: '/collections' },
        { label: 'Accessories', to: '/shop/mens-accessories' },
        { label: 'Sale', to: '/shop/sale' },
      ],
    },
  ],
  spotlight: {
    image: imgMen,
    to: '/shop/men',
    alt: '',
  },
};

export const accessoriesMega = {
  columns: [
    {
      heading: 'ACCESSORIES',
      to: '/shop/accessories',
      links: [
        { label: 'All Accessories', to: '/shop/accessories' },
        { label: 'Bags', to: '/shop/accessories?tag=bags' },
        { label: 'Belts', to: '/shop/accessories?tag=belts' },
        { label: 'Hats', to: '/shop/accessories?tag=hats' },
        { label: 'Jewellery', to: '/shop/accessories?tag=jewellery' },
        { label: 'Sunglasses', to: '/shop/accessories?tag=sunglasses' },
        { label: 'Shoes', to: '/shop/accessories?tag=shoes' },
      ],
    },
  ],
  spotlight: {
    image: imgAccessories,
    to: '/shop/accessories',
    alt: '',
  },
};

export const navItems = [
  { to: '/shop/new', label: 'New In' },
  { to: '/shop/bestsellers', label: 'Best Sellers' },
  { to: '/shop/women', label: 'Women', mega: womenMega },
  { to: '/shop/men', label: 'Men', mega: menMega },
  { to: '/shop/knitwear', label: 'Knitwear' },
  { to: '/shop/dresses', label: 'Dresses' },
  { to: '/shop/accessories', label: 'Accessories' },
  { to: '/collections', label: 'Collections' },
  { to: '/shop/sale', label: 'Sale', accent: true },
];

export function formatMenuPrice(price) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(price);
}
